module.exports = __webpack_public_path__ + "media/images/redesign-images/collabs/collabs-logos/sok-it-88bc3edc76ab5edfd2bb9fd0f12f13cb.svg";